"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basePath = void 0;
exports.fetchData = fetchData;
exports.host = exports.getQueryParams = exports.getItemLabel = void 0;
var _logger = require("../logger");
var _catchPromiseError = require("./catchPromiseError");
var _getUrl = require("./getUrl");
const utilityName = 'bingGeocodingSearch';
const COUNTRY_ENTITY_TYPE = 'CountryRegion';
const catchError = async promise => (0, _catchPromiseError.catchPromiseError)(promise, `Error in ${utilityName}`);

/**
No config for here-used API URL in BackOffice ATM, and probably no need for it.
The API URL setting there https://www.bing.com/api/maps/mapcontrol?callback={0}
is rather a map control script, so probably not much of use here.
API key from BO seems to work here though.

https://dev.virtualearth.net/REST/v1/Locations?query=1%20Microsoft%20Way%20Redmond%20WA%2098052&o=xml&key={BingMapsKey}
*/
const basePath = exports.basePath = '/REST/v1/Locations';
const host = exports.host = 'https://dev.virtualearth.net';
const getQueryParams = (searchText, {
  mapAccount: {
    credentials
  }
}, maxDisplayedSearchResults) => ({
  // TO-DO: culture: localeString, // 'cs', 'en-GB', looks like only selected subset of standard locales is supported
  key: credentials,
  maxResults: maxDisplayedSearchResults,
  query: searchText,
  incl: 'ciso2' // include two-letter ISO country code in results
});
exports.getQueryParams = getQueryParams;
const getItemLabel = address => address.formattedAddress ?? '';
exports.getItemLabel = getItemLabel;
const transformData = (data, tenant) => {
  (0, _logger.logDebug)(`${utilityName} transformData(): data before transformation:\n\t`, data);
  const rawResults = data?.resourceSets[0]?.resources ?? [];
  // Results are filtered to get items relevant to tenant but not to have country only
  const tenantResults = rawResults.filter(item => item.address.countryRegionIso2 === tenant.toUpperCase() && item.entityType !== COUNTRY_ENTITY_TYPE);
  const results = tenantResults.map((item, index) => {
    const {
      address,
      name,
      point: {
        coordinates: [latitude, longitude]
      }
    } = item;
    return {
      id: `${name} | ${index}`,
      label: getItemLabel(address),
      position: {
        latitude,
        longitude
      }
    };
  });
  (0, _logger.logInfo)(`${utilityName}: loaded data after transformation:\n\t`, results);
  return {
    results
  };
};
async function fetchData(options) {
  (0, _logger.logInfo)(`${utilityName}: Loading data ...`);
  const {
    tenant
  } = options;
  const promise = catchError((0, _getUrl.getUrl)({
    ...options,
    /*
    There is wrong CORS implementation of the https://dev.virtualearth.net/REST/v1/Locations
    API, that they don't consider the Access-Control-Request-Headers added automatically by browser,
    or simply don't want to allow any custom headers for some reason.
    */
    isAddingSpecialHeadersForbidden: true
  }));
  const data = await promise;
  return transformData(data, tenant);
}